/**
 * Returns a date string (YYYY-MM-DD) representing one year before the given date.
 * @param fromDate - The reference date. Defaults to current date if not provided.
 * @returns ISO date string in YYYY-MM-DD format
 */
export default function getOneYearAgoDate(fromDate: Date = new Date()): string {
  const oneYearAgo = new Date(fromDate);
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
  // toISOString always returns YYYY-MM-DDTHH:mm:ss.sssZ format
  return oneYearAgo.toISOString().split('T')[0] as string;
}
